<main class="container">
    <div id="containerLeftMenu" style="margin-right: 15px">  
        <left-menu [showImportExport]="false"/>
     </div> 
    <section id="column2">
        <div class="row">
            <div class="col col-12">
                <p>IT contact: <a href="https://go.chevron.com/appsupport" target="_blank" rel="noopener">Please submit a Ticket Request</a></p>
                <p>Content contact: <a href="mailto:AlfonsoRamos@chevron.com">Alfonso Ramos</a></p>
                <p>Content contact: <a href="mailto:JasonWong@chevron.com">Jason Wong</a></p>
            </div>
        </div>
    </section>
</main>
